import { defineStore } from 'pinia';

const useThemeStore = defineStore('theme', {
  state: () => ({
    // Thème sombre actif ou non ; l'état n'est pas persisté, il est perdu au rechargement
    estSombre: false,
  }),

  actions: {
    // Initialise le thème à partir de la préférence du navigateur
    initialiserTheme() {
      this.estSombre = window.matchMedia('(prefers-color-scheme: dark)').matches;
      this.appliquerTheme();
    },

    // Applique le thème courant sur l'élément racine du document
    appliquerTheme() {
      document.documentElement.classList.toggle('theme-sombre', this.estSombre);
      document.documentElement.classList.toggle('theme-clair', !this.estSombre);
    },

    // Bascule entre le thème clair et le thème sombre
    basculerTheme() {
      this.estSombre = !this.estSombre;
      this.appliquerTheme();
    },
  },
});

export default useThemeStore;
